import React, { Component } from 'react';
import { GoogleMap, MarkerF, Autocomplete, InfoWindow } from '@react-google-maps/api';
import { Checkbox } from "@progress/kendo-react-inputs";
import ExpandedPole from "../../global_components/cs_pole_popup";
import loadinggif from "../../assets/loading.gif";
import loadingtext from "../../assets/loadingmaps.png";
import withProject from "../../contexts/class_context_convert.js";
import withTabContext from "../../contexts/report_tab_context_convert.js";
import withHighlightedPoles from "../../contexts/highlighted_poles_class_context_convert.js";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import noaccess from "../../assets/images/noaccess.png";
import othersIcon from "../../assets/SymbologyIcons/selectedBlack.png";
import PIGreen from "../../assets/SymbologyIcons/PIGreen_Circle.png";
import PIRed from "../../assets/SymbologyIcons/PIRed_Circle.png";
import PIYellow from "../../assets/SymbologyIcons/PIYellow_Circle.png";
import PIBlack from "../../assets/SymbologyIcons/PIBlack_Circle.png";
import PRAudited from "../../assets/SymbologyIcons/PRAudited.png";
import PRNotAudited from "../../assets/SymbologyIcons/PRNotAudited.png";
import moment from 'moment'
import { Button } from "@progress/kendo-react-buttons";
import withEnvironmentConfig from '../../contexts/EnvironmentConfigContextClassWrapper';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import addressIcon from "../../assets/SymbologyIcons/searchAddressCenterIcon.png";
import validationIcon from "../../assets/SymbologyIcons/ValidationIcon.png";

const getMapOptions = () => {
    if (window.google && window.google.maps) {
        return {
            fullscreenControl: false,
            styles: [
                {
                    elementType: "labels",
                    featureType: "poi",
                    stylers: [{ visibility: "off" }],
                },
            ],
            mapTypeControl: true,
            mapTypeControlOptions: {
                position: window.google.maps.ControlPosition.TOP_RIGHT,
            },
        };
    }
    return {}; // Fallback if Google Maps is not loaded
};

const containerStyle = {
    width: '100%',
    height: '100%',
    borderRadius: '10px',
    borderColor: '#BFBFBF',
}

const containerStyleFullSize = {
    width: '100%',
    height: '81vh',
    borderRadius: '10px',
    borderColor: '#BFBFBF'
}

const mapSearchOption = ['Pole Number', 'Address'];

class RSPoleMap extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mapData: [],
            currentSelectedPole: null,
            currentCenter: {
                lat: 39.87597539,
                lng: -86.06844941
            },
            showPIInspected: true,
            showPINonRestorableRejects: true,
            showPINotInspected: true,
            showPIRestorableRejects: true,
            showPRAudited: true,
            showPRNotAudited: true,
            showAudited: true,
            showNotAudited: true,
            showOthers: true,
            filteredMapData: [],
            showInfoWindow: true,
            checkedMaplegend: "No Status",
            originalData: null,
            showDrawer: true,
            currentPin: "default",
            legendLoading: true,
            loading: true,
            map: {},
            poleadderList: [],
            poleconditionList: [],
            poleauditstatusList: [],
            rawQuery: null,
            created_user: [],
            Reject_Status: [],
            created_user_checkbox: true,
            Reject_Status_checkbox: true,
            checkboxvalue: false,
            nodata: false,
            dateStart: null,
            dateEnd: null,
            showDate: {},
            counts: 0,
            drawingRec: null,
            lassoWindow: false,
            lassoData: null,
            drawOption: null,
            datevalue: null,
            audit_checkbox: true,
            zoomLevel: 16,
            box: {},
            addressValid: true,
            showErrorMessage: false,
            searchEnteredAddress: ""
        };
        this.autocomplete = null
        this.onLoad = this.onLoad.bind(this)
        this.onPlaceChanged = this.onPlaceChanged.bind(this)
        this.handleMarkerOnClick = this.handleMarkerOnClick.bind(this)
        this.handleMapOnClick = this.handleMapOnClick.bind(this)
        this.handlePoleonChange = this.handlePoleonChange.bind(this)
        this.wrapperRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        if (this.props.projectContext.selectedProject !== "") {
            this.populateMapData("");
        }
                document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    componentDidUpdate(prevProps) {
        const { highlightedPoles } = this.props.highlightedPolesContext;

        // Handle highlighted poles context changes
        if (prevProps.highlightedPolesContext.highlightedPoles !== highlightedPoles) {
            this.updateFilteredMapData();
        }

        // Handle project changes
        if (this.props.projectContext.selectedProject !== prevProps.projectContext.selectedProject) {
            this.setState({ nodata: false, loading: true }, () => {
                this.populateMapData(""); 
                this.handleClearMapFilter(); 
            });
        }
    }

    handleClickOutside(event) {
        if (this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
        this.setState({ showErrorMessage: false });
        }
    }

    handleAddressKeyPress(e) {
    if (e.key === 'Enter') {
        var searchInput = e.target.value;
        console.log(searchInput);
        if (!this.state.map || !searchInput) return;

            const geocoder = new window.google.maps.Geocoder();
            geocoder.geocode({ address: String(searchInput) }, (results, status) => {
                if (status === "OK") {
                    this.setState({
                        currentCenter: results[0].geometry.location,
                        currentSelectedPole: null,
                        isSearchByAddress: true,
                        addressValid: true,
                        showErrorMessage: false
                    });
                }
                else {
                    this.setState({
                        addressValid: false,
                        searchEnteredAddress: searchInput,
                        isSearchByAddress: false,
                    });
                }
            });
        }
        this.boundsCallBack();

    }

    handleWarningIconClick = () => {
        this.setState({
            showErrorMessage: !this.state.showErrorMessage,
        });

    }
    
    handlePoleonChange(e, type, pinType) {
        var locationWaitingStatusList = ["Pole not Set", "Electric Power", "Heavy Vegetation", "Pole Needs Topping", "No Access"]
        var updatedMapData;
        if (type === this.state.checkedMaplegend) {
            this.setState({
                checkedMaplegend: "No Status",
                currentPin: "default",
                currentSelectedPole: null,
                loading: true
            }, () => {
                let boundInput = this.getBounds();
            })
        }
        else {
            this.setState({
                checkedMaplegend: type,
                currentSelectedPole: null,
                currentPin: pinType,
                loading: true
            }, () => {
                let boundInput = this.getBounds();
            })
        }
    }

    handleMarkerOnClick(marker, e) {
        if(marker != null){
            this.setState({
                currentSelectedPole: null,
                currentCenter: null
            }, () => {
                this.setState({
                    currentSelectedPole: marker,
                    currentCenter:marker?.coords
                });
            })
        }

    }

    handleKeyPress(e) {
        if (e.key === 'Enter') {
            var searchInput = e.target.value;
            var lookupData = this.state.mapData;
            var test = lookupData.filter(function (data) {
                return lookupData !== null ? data.info.Pole_Number == searchInput : null
            });

            this.setState({
                currentSelectedPole: null,
                zoomLevel: null
            }, () => {
                this.setState({
                    currentSelectedPole: test.length === 0 ? null : test[0],
                    zoomLevel: 16
                });
            })
        }
    }


    handleMapOnClick() {
        this.setState({
            currentSelectedPole: null,
        })
    }

    handleDraw() {
        this.setState({
            drawOption: "rectangle",
        })
    }

    handleOffDraw() {
        this.state.drawingRec.setMap(null);
        this.setState({
            drawOption: "maker",
            lassoWindow: false
        })
    }

    onLoad(autocomplete) {
        this.autocomplete = autocomplete
    }

    onPlaceChanged() {
        //251-B110
        if (this.autocomplete !== null) {
            var searchCallback = this.autocomplete.getPlace();
            var searchInput = searchCallback.name.toString();
            if (searchCallback.geometry ?.viewport) {
                this.setState({
                    currentCenter: searchCallback.geometry.location,
                    currentSelectedPole: null,
                    isSearchByAddress: true,
                    addressValid: true,
                    showErrorMessage: false
                })
            }
        } else {
            console.log('Autocomplete is not loaded yet!')
                            this.setState({
                    isSearchByAddress: false,
                    addressValid: false,
                });
        }
        this.boundsCallBack();

    }

    showDrawer = () => {
        this.setState({
            showDrawer: !this.state.showDrawer
        })
    }

    getBounds = () => {
        if (!this.state.map || !this.state.map.getBounds) {
            return null;
        }

        let bounds = this.state.map.getBounds();
        if (!bounds) {
            return null; 
        }

        let center = this.state.map.getCenter();

        let lat = center.lat();
        let long = center.lng();

        let ne = bounds.getNorthEast(); // LatLng of the north-east corner
        let sw = bounds.getSouthWest(); // LatLng of the south-west corner

        let bbox = {
            north: ne.lat(),
            east: ne.lng(),
            south: sw.lat(),
            west: sw.lng(),
            lat: lat,
            long: long
        };

        return bbox;
    };

    boundsCallBack = () => {
        setTimeout(() => {
            let boundInput = this.getBounds();
            if (!boundInput) return;
            this.setState({
                box: boundInput
            })
        }, 500)
    }

    boundsZoomCallBack = () => {
        setTimeout(() => {
            let boundInput = this.getBounds();
            if (!boundInput) return;
            this.setState({
                box: boundInput
            })
        }, 1000)
    }

    updateFilteredMapData = () => {
        const { highlightedPoles } = this.props.highlightedPolesContext;

        const {
            mapData,
            showPIInspected,
            showPINonRestorableRejects,
            showPINotInspected,
            showPIRestorableRejects,
            showPRAudited,
            showPRNotAudited,
            showOthers
        } = this.state;

        const filtered = mapData.filter((item) => {
            if (highlightedPoles.length > 0) {
                return highlightedPoles.includes(item.info ?.GlobalID);
            }

            const type = item.info ?.Type;

            // -------- Inspection Poles --------
            if (type === "Inspection Pole") {
                const key = (item.info ?.SymbologyKey || "").toLowerCase();

                if (key === "not_inspected") return showPINotInspected;
                if (key === "inspected") return showPIInspected;
                if (key === "non_restorable_rejects") return showPINonRestorableRejects;
                if (key === "restorable_rejects") return showPIRestorableRejects;

                return showOthers;
            }

            // -------- Restoration Poles --------
            if (type === "Restoration Pole") {
                const isAudited = !!item.info ?.Audit_Date;

                if (isAudited) return showPRAudited;
                return showPRNotAudited;
            }

            // -------- Any unknown --------
            return showOthers;
        });

        this.setState({ filteredMapData: filtered }, () => {
            if (highlightedPoles.length > 0 && filtered.length > 0) {
                const firstHighlightedPole = filtered.find(pole =>
                    highlightedPoles.includes(pole.info ?.GlobalID)
                );
                if (firstHighlightedPole) {
                    this.setState({
                        currentCenter: firstHighlightedPole.coords,
                        zoomLevel: 16
                    });
                }
            }
            this.setState({ legendLoading: false });
        });
    };

    handleMapLoad = (map) => {
        this.setState((state) => ({ ...state, map }));
        setTimeout(() => {
            let boundInput = this.getBounds();
            console.log(boundInput);
            this.setState({
                box: boundInput
            })
        }, 500)
    }

    handleChange = (e) => {
        if (e.value.end != null) {
            this.setState({
                dateStart: moment(e.value.start).format('yyyy-MM-DD hh:mm:ss'),
                dateEnd: moment(e.value.end).format('yyyy-MM-DD hh:mm:ss'),
                showDate: e.value,
            }, () => { this.handleFilterUpdate() })
        }
    }

    handleCleanDate = () => {
        this.setState({
            dateStart: null,
            dateEnd: null,
            showDate: {}
        }, () => { this.handleFilterUpdate() })
    }

    handleClearMapFilter = () => {
        const { setHighlightedPoles } = this.props.highlightedPolesContext;
        setHighlightedPoles([]);

        this.setState(
            {
                showPINotInspected: true,
                showPIInspected: true,
                showPINonRestorableRejects: true,
                showPIRestorableRejects: true,
                showPRAudited: true,
                showPRNotAudited: true,
                showOthers: true,
                currentSelectedPole: null,
            },
            this.updateFilteredMapData
        );
    };

    handleGoToReport = () => {
        const { setSelectedTab } = this.props.tabContext;
        setSelectedTab(1);
        this.props.navigate('/report');

        this.setState({ currentSelectedPole: null });
    }

    handleFilterUpdate = () => {
        this.setState({
            loading: true
        })
        var rawQuery = "";
        var tempQuery = "";
        var tempQuery1 = "";
        var tempQuery2 = "";
        var tempQuery3 = "";
        var temparray = [];
        if (this.state.created_user.length > 0) {
            var tempString = this.state.created_user.map((value) => `${"'" + value + "'"}`).join(',');
            tempQuery = "created_user In (" + tempString + ")";
        }
        else {
            tempQuery = "";
        }

        if (this.state.Reject_Status.length > 0) {
            var tempString = this.state.Reject_Status.map((value) => `${value}`).join(',');
            tempQuery1 = "Reject_Status In (" + tempString + ")";
        }
        else {
            tempQuery1 = "";
        }

        if (this.state.dateEnd != null && this.state.dateStart != null) {
            var tempString = "created_date < '" + this.state.dateEnd + "' and created_date > '" + this.state.dateStart + "'";
            tempQuery2 = tempString;
        }
        else {
            tempQuery2 = "";
        }
        if (this.state.audit_childbox_audited) {
            tempQuery3 = 'audit_user is not null'
        }

        if (tempQuery !== "") {
            temparray.push(tempQuery);
        }
        if (tempQuery1 !== "") {
            temparray.push(tempQuery1);
        }
        if (tempQuery2 !== "") {
            temparray.push(tempQuery2);
        }
        if (tempQuery3 !== "") {
            temparray.push(tempQuery3);
        }
        var rawQuery = temparray.map((value) => `${value}`).join(' and ');
        this.populateMapData(rawQuery);
    }

    handleCondition = (condition) => {
        if (condition === "1") {
            return "Non Reject";
        }
        else if (condition === "2") {
            return "Non Restorable Reject";
        }
        else if (condition === "3") {
            return "Priority Non Restorable Reject";
        }
        else if (condition === "4") {
            return "Priority Restorable Reject";
        }
        else if (condition === "5") {
            return "Restorable Reject";
        }
    }

    assignPoleSymbologyColor = (pole) => {
        const { hasHighlightedPoles, highlightedPoles } = this.props.highlightedPolesContext;

        const isHighlighted = highlightedPoles.includes(pole.info ?.GlobalID);
        const type = pole.info ?.Type;

        const getIcon = () => {
            if (type === "Inspection Pole") {
                switch ((pole.info ?.SymbologyKey || "").toLowerCase()) {
                    case "not_inspected": return PIBlack;
                    case "inspected": return PIGreen;
                    case "non_restorable_rejects": return PIRed;
                    case "restorable_rejects": return PIYellow;
                    default:
                        return othersIcon; 
                }
            }

            if (type === "Restoration Pole") {
                return pole.info ?.Audit_Date ? PRAudited : PRNotAudited;
            }

            // any other Type (or missing) => Others
            return othersIcon;
        };

        if (!hasHighlightedPoles) return getIcon();
        if (isHighlighted) return getIcon();

        return othersIcon;
    };

    render() {
        const { highlightedPoles } = this.props.highlightedPolesContext;

        const filteredMapData = this.state.filteredMapData;

        const legendWithoutFilterApplied = (
            <div className="pulse-map-legend-rs">
                <div className="pulse-map-legend-rs-container">
                    <GridLayout
                        rows={[
                            { height: 25 }, 
                            { height: 25 }, 
                            { height: 25 }, 
                            { height: 25 }, 
                            { height: 25 }, 
                        ]}
                        cols={[
                            { width: 20 },
                            { width: 20 },
                            { width: 20 },
                            { width: 80 },
                        ]}
                        gap={{ rows: 3, cols: 4 }}
                    >
                        {/* Group toggle */}
                        <GridLayoutItem row={1} col={1}>
                            <Checkbox
                                checked={
                                    this.state.showPINotInspected ||
                                    this.state.showPIInspected ||
                                    this.state.showPINonRestorableRejects ||
                                    this.state.showPIRestorableRejects
                                }
                                style={{ borderColor: "#051A38", borderWidth: "1px", width: "18px", height: "18px" }}
                                onChange={(e) => {
                                    const isChecked = e.syntheticEvent.target.checked;
                                    this.setState(
                                        {
                                            showPINotInspected: isChecked,
                                            showPIInspected: isChecked,
                                            showPINonRestorableRejects: isChecked,
                                            showPIRestorableRejects: isChecked,
                                            currentSelectedPole: null
                                        },
                                        this.updateFilteredMapData
                                    );
                                }}
                            />
                        </GridLayoutItem>

                        <GridLayoutItem row={1} col={2} colSpan={3}>
                            <div className="legend-row-rs">Pole Inspection</div>
                        </GridLayoutItem>

                        {/* Row 2: Not Inspected */}
                        <GridLayoutItem row={2} col={2}>
                            <Checkbox
                                value={this.state.showPINotInspected}
                                className="legend-checkbox"
                                style={{
                                    backgroundColor: this.state.showPINotInspected ? "#000" : "#FFFFFF",
                                    borderColor: "#051A38",
                                    borderWidth: "1px",
                                    width: "20px",
                                    height: "20px",
                                }}
                                onChange={(e) => {
                                    const isChecked = e.syntheticEvent.target.checked;
                                    this.setState(
                                        { showPINotInspected: isChecked, currentSelectedPole: null },
                                        this.updateFilteredMapData
                                    );
                                }}
                            />
                        </GridLayoutItem>
                        <GridLayoutItem row={2} col={3}>
                            <img className="pulse-map-legend-icon" src={PIBlack} alt="Pole" />
                        </GridLayoutItem>
                        <GridLayoutItem row={2} col={4}>Not Inspected</GridLayoutItem>

                        {/* Row 3: Inspected */}
                        <GridLayoutItem row={3} col={2}>
                            <Checkbox
                                value={this.state.showPIInspected}
                                className="legend-checkbox"
                                style={{
                                    backgroundColor: this.state.showPIInspected ? "#20790A" : "#FFFFFF",
                                    borderColor: "#051A38",
                                    borderWidth: "1px",
                                    width: "20px",
                                    height: "20px",
                                }}
                                onChange={(e) => {
                                    const isChecked = e.syntheticEvent.target.checked;
                                    this.setState(
                                        { showPIInspected: isChecked, currentSelectedPole: null },
                                        this.updateFilteredMapData
                                    );
                                }}
                            />
                        </GridLayoutItem>
                        <GridLayoutItem row={3} col={3}>
                            <img className="pulse-map-legend-icon" src={PIGreen} alt="Pole" />
                        </GridLayoutItem>
                        <GridLayoutItem row={3} col={4}>Inspected</GridLayoutItem>

                        {/* Row 4: Non Restorable Rejects */}
                        <GridLayoutItem row={4} col={2}>
                            <Checkbox
                                checked={this.state.showPINonRestorableRejects}
                                className="legend-checkbox"
                                style={{
                                    backgroundColor: this.state.showPINonRestorableRejects ? "#FF0000" : "#FFFFFF",
                                    borderColor: "#051A38",
                                    borderWidth: "1px",
                                    width: "20px",
                                    height: "20px",
                                }}
                                onChange={(e) => {
                                    const isChecked = e.syntheticEvent.target.checked;
                                    this.setState(
                                        { showPINonRestorableRejects: isChecked, currentSelectedPole: null },
                                        this.updateFilteredMapData
                                    );
                                }}
                            />
                        </GridLayoutItem>
                        <GridLayoutItem row={4} col={3}>
                            <img className="pulse-map-legend-icon" src={PIRed} alt="Pole" />
                        </GridLayoutItem>
                        <GridLayoutItem row={4} col={4}>Non Restorable Rejects</GridLayoutItem>

                        {/* Row 5: Restorable Rejects */}
                        <GridLayoutItem row={5} col={2}>
                            <Checkbox
                                value={this.state.showPIRestorableRejects}
                                className="legend-checkbox"
                                style={{
                                    backgroundColor: this.state.showPIRestorableRejects ? "#FFC517" : "#FFFFFF",
                                    borderColor: "#051A38",
                                    borderWidth: "1px",
                                    width: "20px",
                                    height: "20px",
                                }}
                                onChange={(e) => {
                                    const isChecked = e.syntheticEvent.target.checked;
                                    this.setState(
                                        { showPIRestorableRejects: isChecked, currentSelectedPole: null },
                                        this.updateFilteredMapData
                                    );
                                }}
                            />
                        </GridLayoutItem>
                        <GridLayoutItem row={5} col={3}>
                            <img className="pulse-map-legend-icon" src={PIYellow} alt="Pole" />
                        </GridLayoutItem>
                        <GridLayoutItem row={5} col={4}>Restorable Rejects</GridLayoutItem>
                    </GridLayout>
                </div>
                <div className="pulse-map-legend-rs-container">
                    <GridLayout
                        rows={[{
                            height: 25
                        }, {
                                height: 25
                        }, {
                                height: 25
                            }]}
                        cols={[{
                            width: 20
                        }, {
                            width: 20
                        }, {
                            width: 20
                        }, {
                            width: 80
                        }]}
                        gap={{
                            rows: 3,
                            cols: 4,
                        }}
                    >
                        <GridLayoutItem row={1} col={1} className="" >
                            <Checkbox
                                checked={(this.state.showPRAudited || this.state.showPRNotAudited) ? true : false}
                                style={{ borderColor: "#051A38", borderWidth: "1px", width: "18px", height: "18px" }}
                                onChange={(e) => {
                                    const isChecked = e.syntheticEvent.target.checked;
                                    this.setState(
                                        { showPRAudited: isChecked, showPRNotAudited: isChecked, currentSelectedPole: null, },
                                        this.updateFilteredMapData
                                    );
                                }}
                            />
                        </GridLayoutItem>
                        <GridLayoutItem row={1} col={2} colSpan={3} className="" >
                            <div className="legend-row-rs">
                                Pole Restoration
                            </div>
                        </GridLayoutItem>
                        <GridLayoutItem row={2} col={2} className="" >
                            <Checkbox
                                checked={this.state.showPRAudited}
                                style={{ backgroundColor: this.state.showPRAudited ? "#20790A" : "#FFFFFF", borderColor: "#051A38", borderWidth: "1px", width: "20px", height: "20px" }}
                                className="legend-checkbox"
                                onChange={(e) => {
                                    const isChecked = e.syntheticEvent.target.checked;
                                    this.setState(
                                        { showPRAudited: isChecked, currentSelectedPole: null, },
                                        this.updateFilteredMapData
                                    );
                                }}
                            />
                        </GridLayoutItem>
                        <GridLayoutItem className="" row={2} col={3}>
                            <img className="pulse-map-legend-icon-PR" src={PRAudited} alt="Pole" />
                        </GridLayoutItem>
                        <GridLayoutItem className="" row={2} col={4}>
                            <div className="">
                                Audited
                            </div>
                        </GridLayoutItem>
                        <GridLayoutItem row={3} col={2} className="" >
                            <Checkbox
                                checked={this.state.showPRNotAudited}
                                className="legend-checkbox"
                                style={{ backgroundColor: this.state.showPRNotAudited ? "#FF0000" : "#FFFFFF", borderColor: "#051A38", borderWidth: "1px", width: "20px", height: "20px" }}
                                onChange={(e) => {
                                    const isChecked = e.syntheticEvent.target.checked;
                                    this.setState(
                                        { showPRNotAudited: isChecked, currentSelectedPole: null, },
                                        this.updateFilteredMapData
                                    );
                                }}
                            />
                        </GridLayoutItem>
                        <GridLayoutItem row={3} col={3} className="" >
                            <img className="pulse-map-legend-icon-PR" src={PRNotAudited} alt="Pole" />
                        </GridLayoutItem>
                        <GridLayoutItem className="" row={3} col={4}>
                            <div className="" >
                                Not Audited
                            </div>
                        </GridLayoutItem>
                    </GridLayout>
                </div>

                <div className="pulse-map-legend-rs-container">
                    <GridLayout
                        rows={[
                            { height: 25 },
                            { height: 25 },
                        ]}
                        cols={[
                            { width: 20 },
                            { width: 20 },
                            { width: 20 },
                            { width: 80 },
                        ]}
                        gap={{ rows: 3, cols: 4 }}
                    >
                        <GridLayoutItem row={1} col={2} colSpan={3}>
                            <div className="legend-row-rs">Others</div>
                        </GridLayoutItem>

                        <GridLayoutItem row={2} col={2}>
                            <Checkbox
                                checked={this.state.showOthers}
                                className="legend-checkbox"
                                style={{
                                    backgroundColor: this.state.showOthers ? "#000" : "#FFFFFF",
                                    borderColor: "#051A38",
                                    borderWidth: "1px",
                                    width: "20px",
                                    height: "20px",
                                }}
                                onChange={(e) => {
                                    const isChecked = e.syntheticEvent.target.checked;
                                    this.setState(
                                        { showOthers: isChecked, currentSelectedPole: null },
                                        this.updateFilteredMapData
                                    );
                                }}
                            />
                        </GridLayoutItem>
                        <GridLayoutItem row={2} col={3}>
                            <img className="pulse-map-legend-icon" src={othersIcon} alt="Others" />
                        </GridLayoutItem>

                        <GridLayoutItem row={2} col={4}>Others</GridLayoutItem>
                    </GridLayout>
                </div>
            </div>
        );

        const legendWithFilterApplied = (
            <div className="pulse-map-legend-rs">
                <div className="pulse-map-legend-rs-container">
                    <GridLayout
                        rows={[
                            { height: 25 }, 
                            { height: 25 }, 
                            { height: 25 }, 
                            { height: 25 }, 
                            { height: 25 }, 
                        ]}
                        cols={[
                            { width: 20 },
                            { width: 20 },
                            { width: 80 },
                        ]}
                        gap={{ rows: 3, cols: 3 }}
                    >
                        <GridLayoutItem row={1} col={1} colSpan={3}>
                            <div className="legend-row-rs">Pole Inspection</div>
                        </GridLayoutItem>

                        {/* Row 2: Not Inspected */}
                        <GridLayoutItem row={2} col={2}>
                            <img className="pulse-map-legend-icon" src={PIBlack} alt="Pole" />
                        </GridLayoutItem>
                        <GridLayoutItem row={2} col={3}>Not Inspected</GridLayoutItem>

                        {/* Row 3: Inspected */}
                        <GridLayoutItem row={3} col={2}>
                            <img className="pulse-map-legend-icon" src={PIGreen} alt="Pole" />
                        </GridLayoutItem>
                        <GridLayoutItem row={3} col={3}>Inspected</GridLayoutItem>

                        {/* Row 4: Non Restorable Rejects*/}
                        <GridLayoutItem row={4} col={2}>
                            <img className="pulse-map-legend-icon" src={PIRed} alt="Pole" />
                        </GridLayoutItem>
                        <GridLayoutItem row={4} col={3}>Non Restorable Rejects</GridLayoutItem>

                        {/* Row 5: Restorable Rejects */}
                        <GridLayoutItem row={5} col={2}>
                            <img className="pulse-map-legend-icon" src={PIYellow} alt="Pole" />
                        </GridLayoutItem>
                        <GridLayoutItem row={5} col={3}>Restorable Rejects</GridLayoutItem>
                    </GridLayout>
                </div>
                <div className="pulse-map-legend-rs-container">
                    <GridLayout
                        rows={[{
                            height: 25
                        }, {
                            height: 25
                        }, {
                            height: 25
                        }]} cols={[{
                            width: 20
                        }, {
                            width: 20
                        }, {
                            width: 80
                        }]}
                        gap={{
                            rows: 3,
                            cols: 3,
                        }}
                    >
                        <GridLayoutItem row={1} col={1} colSpan={3} className="" >
                            <div className="legend-row-rs">
                                Pole Restoration
                        </div>
                        </GridLayoutItem>
                        <GridLayoutItem className="" row={2} col={2}>
                            <img className="pulse-map-legend-icon-PR" src={PRAudited} alt="Pole" />
                        </GridLayoutItem>
                        <GridLayoutItem className="" row={2} col={3}>
                            <div className="">
                                Audited
                            </div>
                        </GridLayoutItem>

                        <GridLayoutItem row={3} col={2} className="" >
                            <img className="pulse-map-legend-icon-PR" src={PRNotAudited} alt="Pole" />
                        </GridLayoutItem>
                        <GridLayoutItem className="" row={3} col={3}>
                            <div className="" >
                                Not Audited
                            </div>
                        </GridLayoutItem>
                    </GridLayout>
                </div>
                <div className="pulse-map-legend-rs-container">
                    <GridLayout
                        rows={[{ height: 25 }, { height: 25 }]}
                        cols={[{ width: 20 }, { width: 20 }, { width: 80 }]}
                        gap={{ rows: 3, cols: 3 }}
                    >
                        <GridLayoutItem row={1} col={1} colSpan={3}>
                            <div className="legend-row-rs">Others</div>
                        </GridLayoutItem>

                        <GridLayoutItem row={2} col={2}>
                            <img className="pulse-map-legend-icon" src={othersIcon} alt="Others" />
                        </GridLayoutItem>
                        <GridLayoutItem row={2} col={3}>Others</GridLayoutItem>
                    </GridLayout>
                </div>

            </div>
        );

        const NoDataComponent = () => (
            <div>
                <img className='pulse-no-access-image' src={noaccess} alt="No Access" />
                <h3 className='pulse-no-access-image-text'>This project does not have any data yet.</h3>
            </div>
        );

        return (
            <>
                {this.state.nodata ? (
                    <NoDataComponent />
                ) : this.state.loading ? (
                    <div className='nimbly2-map-loader-rs'>
                        <img className='nimbly2-map-loader-gif-rs' src={loadinggif} alt="Loading..." />
                        <img className='nimbly2-map-loader-text-rs' src={loadingtext} alt="Loading Text" />
                    </div>
                    ) : (

                            <div className={this.state.loading ? "nimbly-map-loading" : "map-container"} >

                                <GoogleMap
                                    mapContainerStyle={this.props.fullSizeMap ? containerStyleFullSize : containerStyle}
                                    center={this.state.currentCenter}
                                    zoom={this.state.zoomLevel}
                                    // options={getMapOptions()}
                                    onFail={error => console.log(error)}
                                    onDragEnd={this.boundsCallBack}
                                    onLoad={this.handleMapLoad}
                                    onZoomChanged={this.boundsZoomCallBack}
                                                                                                options={{
                                        mapTypeControl: true,
                                        mapTypeControlOptions: {
                                            position: window.google.maps.ControlPosition.BOTTOM_RIGHT,
                                        },
                                        fullscreenControl: true,
                                        fullscreenControlOptions: {
                                            position: window.google.maps.ControlPosition.BOTTOM_RIGHT,
                                        }
                                    }}
                                >
                                    <div className="map-button-group">
                                        <Button
                                            onClick={() => this.handleClearMapFilter()}
                                            className="map-button"
                                        >
                                            Reset Map Filter
                                        </Button>
                                        {highlightedPoles && highlightedPoles.length > 0 && (
                                            <Button
                                                onClick={() => this.handleGoToReport()}
                                                className="map-button"
                                            >
                                                Go to Report
                                            </Button>
                                        )}
                                    </div>
                                    {
                                        <div>
                                            <div>

                                    <GridLayout gap={{
                                        cols: 0,
                                        row: 6
                                    }}
                                        className={highlightedPoles && highlightedPoles.length > 0 ? "pulse-map-searchbox-container-querymap" : "pulse-map-searchbox-container"}
                                    >
                                        <GridLayoutItem className="box" col={1} row={1}>
                                                <Autocomplete
                                                    onLoad={this.onLoad}
                                                    onPlaceChanged={this.onPlaceChanged}
                                                >
                                                    <input
                                                        type="text"
                                                        placeholder="Search by Address"
                                                        className={this.state.addressValid ? "pulse-map-searchbox-input-addressOnly" : "pulse-map-searchbox-input-addressOnly pulse-map-searchbox-input-error"}
                                                        onKeyUp={(e) => this.handleAddressKeyPress(e)}

                                                    />
                                                </Autocomplete>
                                        </GridLayoutItem>
                                        <GridLayoutItem className="box rect parent" col={2} row={1} >
                                            {this.state.addressValid ? null :
                                                <span className="pulse-input-icon">
                                                    <img
                                                        src={validationIcon}
                                                        alt="Warning"
                                                        className="pulse-address-search-warning-icon"
                                                        onMouseDown={(e) => e.target.style.transform = 'scale(0.9)'} // Visual feedback
                                                        onMouseUp={(e) => e.target.style.transform = 'scale(1)'}
                                                        onClick={() => this.handleWarningIconClick()}
                                                    />
                                                </span>
                                            }
                                        </GridLayoutItem>

                                        <GridLayoutItem className="box rect" col={1} row={2} colSpan={2}>
                                            {
                                                this.state.showErrorMessage ?
                                                    <div className="white-box"  ref={this.wrapperRef} >
                                                        <h2 className="box-header">Maps cannot find {this.state.searchEnteredAddress}.</h2>
                                                        <p className="box-content">
                                                            Make sure your search is spelled correctly.Try adding a city, state, or zip code.
                                            </p>
                                                    </div> : null
                                            }
                                        </GridLayoutItem>
                                    </GridLayout>
                                    {this.state.isSearchByAddress ?
                                        <MarkerF
                                            key={this.state.currentCenter}
                                            position={this.state.currentCenter}
                                            icon={addressIcon}
                                        >
                                        </MarkerF> : null
                                    }
                                            </div>
                                        </div>

                                    }
                                    {
                                        this.state.filteredMapData == null || this.state.filteredMapData.length <= 0
                                            ? (
                                                "loading"
                                            )
                                            : (
                                                <>
                                                    {this.state.box && this.state.filteredMapData.map((item, index) => (
                                                        item.coords.lat <= this.state.box.north && item.coords.lat >= this.state.box.south && item.coords.lng >= this.state.box.west && item.coords.lng <= this.state.box.east ?
                                                        <MarkerF
                                                            key={index}
                                                            position={item.coords}
                                                            onClick={(e) => this.handleMarkerOnClick(item, e)}
                                                            icon={this.assignPoleSymbologyColor(item)}
                                                        >
                                                            {this.state.currentSelectedPole !== null &&
                                                                this.state.currentSelectedPole.info.GlobalID === item.info.GlobalID && (
                                                                    <InfoWindow key={index} position={item.coords} onCloseClick={() => this.setState({ currentSelectedPole: null })}>
                                                                    <ExpandedPole item={item} />
                                                                    </InfoWindow>
                                                                )}
                                                        </MarkerF> : null
                                                    ))}
                                                </>
                                            )
                                    }
                                    <></>
                                </GoogleMap>
                                {
                                    !this.state.loading && (
                                        highlightedPoles && highlightedPoles.length > 0
                                            ? legendWithFilterApplied
                                            : legendWithoutFilterApplied
                                    )}
                            </div>
                        )}
            </>
        );
    }

    async populateMapData(rawQuery) {
        const { selectedProject, GCP_Project, Dataset_ID } = this.props.projectContext;
        const { environmentConfig } = this.props.environmentConfigContext;

        const payload = {
            Dataset_ID: Dataset_ID,
            GCP_Project: GCP_Project,
            Project: selectedProject,
            Location: {
                ColumnName: "Coordinates",
                TableName: "Location_Details",
            },
            Search: {
                ColumnName: "Address",
                TableName: "Location_Details",
            },
            UniqueID: {
                ColumnName: "GlobalID",
                TableName: "Poles",
            },
            Category: {
                ColumnName: "Symbology",
                TableName: "Poles",
            },
            Type: {
                ColumnName: "Type",
                TableName: "Poles",
            },
            AuditDate: {
                ColumnName: "Audit Date",
                TableName: "Poles"
            },
            RejectPole: {
                ColumnName: "Reject Pole",
                TableName: "Poles"
            },
            NonRestorableRejectStatus: {
                ColumnName: "Non Restorable Reject Status",
                TableName: "Poles"
            },
            RestorableRejectStatus: {
                ColumnName: "Restorable Reject Status",
                TableName: "Poles"
            },
        };

        this.setState({ loading: true });

        fetch(`${process.env.REACT_APP_WEB_API_URL}/api-common/poles/GetBriefPoles`, {
            method: 'POST',
            headers: {
                'frontendenvironmentconfig': environmentConfig,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
            .then((res) => res.json())
            .then((data) => {
                const markerList = data.map(pole => {
                    let arr = pole.Location.split("-");
                    if (arr.length === 2) {
                        let lat = Number(arr[0]);
                        let lng = -(Number(arr[1]));

                        return {
                            coords: { lat, lng },
                            info: {
                                GlobalID: pole.GlobalID,
                                Audit_Date: pole.Category,
                                Address: pole.Search || null,
                                Type: pole.Type,
                                SymbologyKey: pole.SymbologyKey || null
                            },
                            highlighted: this.props.highlightedPolesContext.highlightedPoles.includes(pole.GlobalID),
                        };
                    }
                    return null;
                }).filter(Boolean);

                this.setState({
                    mapData: markerList,
                    filteredMapData: markerList,
                    currentCenter: markerList[0] ?.coords || { lat: 0, lng: 0 },
                    counts: markerList.length,
                    loading: false,
                }, this.updateFilteredMapData);
            })
            .catch(() => this.setState({ loading: false }));
    }
}
export default withEnvironmentConfig(withProject(withHighlightedPoles(withTabContext(RSPoleMap))));
